export const tableLightTheme = {
  mode: 'light',
  cell: {
    background: {
      default: '#EFEFEF',
      alt: '#FFFFFF',
    },
    text: 'dimgray',
  },
  tooltip: {
    background: '#F5F5F5',
    text: 'dimgray',
  },
  tint: '#424242',
};

export const tableDarkTheme = {
  mode: 'dark',
  cell: {
    background: {
      default: '#424242',
      alt: '#5D5D5D',
    },
    text: '#EEEEEE',
  },
  tooltip: {
    background: '#303030',
    text: '#EEEEEE',
  },
  tint: '#EEEEEE',
};
